import React from 'react'
import {Helmet} from "react-helmet";
import PageTitle from '../../pagetitle/PageTitle'
import DuzenlemeKurulu from '../../kurullar/DuzenlemeKurulu'

export default function Duzenleme()
{
    const title = "OKAF Düzenleme Kurulu - Samsun Üniversitesi";
    const description = "Samsun Üniversitesi ev sahipliğinde gerçekleşecek olan Orta Karadeniz Kariyer Fuarı (OKAF)'ın düzenleme kurulu hakkında ayrıntılı bilgi için tıklayınız!";
    return (
        <>
            <Helmet>
                <title>{title}</title>
                <meta name="description" content={description} />
            </Helmet>
            <PageTitle name="Düzenleme Kurulu"></PageTitle>
            <DuzenlemeKurulu></DuzenlemeKurulu>
        </>
    )
}
